import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogIn, Package, Calendar, UserPlus, CheckCircle2, Zap } from 'lucide-react';

export default function LoginForm({ onLogin, onRegister, registered }) {
  return (
    <div className="min-h-screen bg-[#0d0d0f] pt-16 flex items-center justify-center">

      <div className="w-full max-w-md px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <Link to="/">
              <img
                src="https://media.base44.com/images/public/69e7659143303e8153678f84/d1f090528_Asset1.png"
                alt="Motion Reality"
                className="h-10 w-auto"
              />
            </Link>
          </div>

          {/* Badge */}
          <div className="flex justify-center mb-5">
            <span className="inline-flex items-center gap-2 border border-white/10 text-white/40 text-[10px] font-bold tracking-[0.2em] px-3 py-1.5">
              <Zap className="w-3 h-3 text-primary" />
              CUSTOMER PORTAL
            </span>
          </div>

          <h1 className="text-white font-black text-3xl md:text-4xl uppercase leading-tight mb-2">
            My Account
          </h1>
          <p className="text-white/30 text-sm mb-10 leading-relaxed max-w-xs mx-auto">
            Sign in to track orders and manage your sim rig bookings.
          </p>

          {registered && (
            <div className="flex items-center gap-3 bg-green-400/10 border border-green-400/20 text-green-400 text-sm px-4 py-3 mb-8 text-left">
              <CheckCircle2 className="w-5 h-5 shrink-0" />
              Account created! Check your email for a verification code to activate your account.
            </div>
          )}

          {/* Feature cards */}
          <div className="grid grid-cols-2 gap-3 mb-10">
            {[
              { icon: Package, label: 'TRACK ORDERS', desc: 'Payment status & order details' },
              { icon: Calendar, label: 'MY BOOKINGS', desc: 'Upcoming sim rig sessions' },
            ].map(({ icon: Icon, label, desc }) => (
              <div key={label} className="bg-white/[0.02] border border-white/5 p-5 text-left">
                <div className="w-7 h-7 bg-primary/10 flex items-center justify-center mb-3">
                  <Icon className="w-3.5 h-3.5 text-primary" />
                </div>
                <p className="text-white font-bold text-[10px] tracking-widest mb-1">{label}</p>
                <p className="text-white/30 text-[11px] leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="w-8 h-px bg-white/10 mx-auto mb-8" />

          {/* CTAs */}
          <div className="space-y-3">
            <button
              onClick={onLogin}
              className="w-full bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-widest py-4 transition-colors flex items-center justify-center gap-2"
            >
              <LogIn className="w-4 h-4" /> SIGN IN TO MY ACCOUNT
            </button>

            <button
              onClick={onRegister}
              className="w-full border border-white/10 hover:border-white/25 text-white/50 hover:text-white font-bold text-xs tracking-widest py-4 transition-all flex items-center justify-center gap-2"
            >
              <UserPlus className="w-4 h-4" /> CREATE AN ACCOUNT
            </button>
          </div>

          <p className="text-white/20 text-xs text-center mt-8">
            Need help?{' '}
            <a href="mailto:sales@motionreality.co.uk" className="text-primary hover:underline">
              Contact us
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}